export const idea = {
    title: "Your Idea",
    subtitle: "basic details of your idea",
    ideaCategory: ["Personal", "Business"],
    ideaCharLimit : 50
}
export const ideaTermsAndConditions = 'I agree to <a target="_blank" href="https://www.feijoa8.com/terms">Terms and Conditions</a>.';
